import React from 'react'
import SearchBar from '../SearchBar/SearchBar'
import Title from 'antd/es/typography/Title'
import styles from './TitleSearch.module.css'
import {Flex, Layout, Row, Tag } from 'antd';

const TitleSearch = () => {
  return (
    <>
    <Flex style={{marginTop: "30px"}} justify='end' gap='10px' align="center" vertical>
    <Title className={styles.title} level={3}>Search Smarter, Explore Better<br/>Elevate Your Online Exploration Today!</Title>
    <SearchBar></SearchBar>
    </Flex>
    </>
  )
}

export default TitleSearch